import React, { useState } from "react";
import Registration from "../components/Registration";


function Home() {
 
  return (
    <>
      {/* <Banner /> */}
      <div className="">
        {/* <RegistrationFrom /> */}
        <Registration />

      </div>
    </>
  );
}

export default Home;
